import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { RiTeamFill } from 'react-icons/ri'
import { useSelector } from 'react-redux'
import { HeaderActions, IUser } from 'safe'
import Loading from '../../components/Display/Loading'
import Modal from '../../components/Display/Modal'
import { ThemeContext } from '../../context/ThemeContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import { AuthService } from '../../services/AuthService'
import WaiterCard from './WaiterCard'
import WaiterForm from './WaiterForm'

const server = process.env.REACT_APP_SERVER_URL
let authService = new AuthService()

export const Waiters: React.FC<FoodTableProps> = ({ setHeaderActions }) => {
  const [waiters, setWaiters] = useState<IUser[]>([])

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [isLoadingGet, setIsLoadingGet] = useState<boolean>(false)

  const [createModal, setCreateModal] = useState<boolean>(false)

  const [selectedUser, setSelectedUser] = useState<IUser | null>(null)

  const [useType, setuseType] = useState<'create' | 'edit' | 'watch'>('create')

  const { addAlert } = useSnackBars()
  const { theme } = useContext(ThemeContext)

  const user = useSelector((state: RootState) => state.auth.user)
  const userPlan = user?.['custom:user_plan']
  const isEmprendedorUser =
    userPlan === 'emprendedor' || userPlan === 'estudiantil'

  const onGetWaiters = async () => {
    try {
      setIsLoadingGet(true)
      let response = await axios.get(`${server}/user`)
      setWaiters(
        response?.data?.users?.filter((user: any) => user.userRole === 'waiter')
      )
      setIsLoadingGet(false)
    } catch (error) {
      console.log(error)
      setIsLoadingGet(false)
    }
  }

  const onSubmit = async (values: any): Promise<void> => {
    if (useType === 'create') {
      try {
        addAlert({
          message: 'Creando usuario',
          status: 'loading',
        })
        let userResponse = await authService.signUp(
          values.email,
          values.password,
          values.realName,
          user['custom:tenant_id'],
          user['custom:user_plan'],
          false,
          'waiter'
        )
        const { password, password2, ...rest } = values
        let response = await axios.post(`${server}/user`, {
          ...rest,
          idNevulaUser: userResponse?.userSub,
          userRole: 'waiter',
        })

        await onGetWaiters()

        addAlert({
          message: 'Usuario creado satisfactoriamente',
          status: 'success',
        })
        setCreateModal(false)
      } catch (err: any) {
        if (err?.name === 'InvalidPasswordException') {
          addAlert({
            message:
              'La contraseña es inválida, debe de tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial',
            status: 'error',
          })
          return
        }

        if (err?.name === 'UsernameExistsException') {
          addAlert({
            message: 'Ya existe un usuario con este correo electrónico',
            status: 'error',
          })
          return
        }

        if (
          err?.response?.data?.message ===
          'You have reached your user quota limit'
        ) {
          addAlert({
            message:
              'Has llegado al número máximo de usuarios permitidos en este plan',
            status: 'error',
          })
          return
        }

        addAlert({
          message: 'Error al crear usuario',
          status: 'error',
        })
      }
    } else if (useType === 'edit') {
      addAlert({
        message: 'Cargando',
        status: 'loading',
      })
      try {
        if (values.enabled == 'true') {
          await Promise.all([
            await axios.patch(`${server}/user`, {
              ...values,
              idNevulaUser: selectedUser?.idNevulaUser,
            }),
            await axios.post(`${server}/cognito/enable`, {
              userId: selectedUser?.idNevulaUser,
            }),
          ])
        } else {
          await Promise.all([
            await axios.patch(`${server}/user`, {
              ...values,
              idNevulaUser: selectedUser?.idNevulaUser,
            }),
            await axios.post(`${server}/cognito/disable`, {
              userId: selectedUser?.idNevulaUser,
            }),
          ])
        }

        await onGetWaiters()
        onCloseModal()

        addAlert({
          message: 'Mesonero modificado satisfactoriamente',
          status: 'success',
        })
      } catch (err: any) {
        if (err?.name === 'InvalidPasswordException') {
          addAlert({
            message:
              'La contraseña es inválida, debe de tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial',
            status: 'error',
          })
          return
        }

        if (err?.name === 'UsernameExistsException') {
          addAlert({
            message: 'Ya existe un usuario con este correo electrónico',
            status: 'error',
          })
          return
        }

        addAlert({
          message: 'Error al modificar mesonero',
          status: 'error',
        })
      }
    }
  }

  useEffect(() => {
    // No cargar datos ni mostrar acciones si es plan emprendedor
    if (!isEmprendedorUser) {
      onGetWaiters()

      setHeaderActions({
        addAction: () => {
          console.log('accion')
          setCreateModal(true)
          setuseType('create')
        },
      })
    } else {
      setHeaderActions({})
    }

    return () => {
      setHeaderActions(null)
    }
  }, [isEmprendedorUser])

  const onDelete = async (id: string) => {
    try {
      addAlert({
        message: 'Eliminando mesonero...',
        status: 'loading',
      })
      await axios.delete(`${server}/waiters?id=${id}`)
      await onGetWaiters()
      addAlert({
        message: 'Mesonero eliminado correctamente',
        status: 'success',
      })
    } catch (error) {
      addAlert({
        message: 'Error al eliminar mesonero',
        status: 'error',
      })
    }
  }

  const onCloseModal = () => {
    setCreateModal(false)
    setuseType('create')
    setSelectedUser(null)
  }

  const onWatch = async (user: IUser) => {
    setuseType('watch')
    setSelectedUser(user)
    setCreateModal(true)
  }

  const onEdit = async (user: IUser) => {
    setuseType('edit')
    setSelectedUser(user)
    setCreateModal(true)
  }

  if (isLoadingGet) {
    return <Loading />
  }

  // Mostrar mensaje de upgrade si es plan emprendedor
  if (isEmprendedorUser) {
    return (
      <div className="flex flex-col justify-center items-center h-full p-4">
        <div
          className="p-8 rounded-lg shadow-lg max-w-2xl text-center"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="mb-6">
            <RiTeamFill
              className="mx-auto mb-4"
              size={64}
              style={{ color: '#507CDC' }}
            />
          </div>
          <h2 className="text-2xl font-bold mb-4 dark:text-white">
            Funcionalidad Premium
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            Para gestionar mesoneros debes mejorar tu plan a{' '}
            <strong className="text-primary">"PYME"</strong>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            El plan Corporativo incluye gestión completa de mesoneros con
            registro de usuarios, asignación de mesas, historial de ventas y
            mucho más.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {waiters?.length === 0 && !isLoadingGet && (
        <div className="flex justify-center items-center h-[60vh]">
          <h1 className="text-2xl font-bold">No hay mesoneros disponibles</h1>
        </div>
      )}
      {waiters?.length > 0 && (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
          {waiters.map((user) => (
            <WaiterCard
              user={user}
              onDelete={onDelete}
              onWatch={() => onWatch(user)}
              onEdit={() => onEdit(user)}
            />
          ))}
        </div>
      )}
      <Modal
        xlClasses="w-[700px]"
        display={createModal}
        onClose={() => onCloseModal()}
      >
        <WaiterForm
          onSubmit={onSubmit}
          onClose={() => onCloseModal()}
          useType={useType}
          isLoading={isLoading}
          defaultValues={selectedUser!}
        />
      </Modal>
    </div>
  )
}

interface FoodTableProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
}
